
const style: any = (): any => ({
	headerFooterContainer: {
		display: "flex",
		flexDirection: "row-reverse",
		width: "100%"
	},
});

export default style;